// import httpServer from '@utils/request'
import request from '@/utils/request';
import { DealerLoginInterface, loginInterface } from './type';

export const getDicList = (data: any): Promise<{}> => {
  return request({
    url: '/system/dict/querySystemDict',
    method: 'post',
    data
  });
};

export const getLogin = (data: loginInterface): Promise<{ token: string }> => {
  return request({
    url: '/system/login/signin',
    method: 'post',
    data
  });
};
export const getLogout = (): Promise<{}> => {
  return request({
    url: '/system/login/signout',
    method: 'post'
  });
};

export const getCurrentUser = (data: {}): Promise<any> => {
  return request({
    url: '/system/user/getUserDetail',
    method: 'post',
    data
  });
};
export const getEmailCode = (data?: any): Promise<any> => {
  return request({
    url: '/system/login/sendEmailCode',
    method: 'post',
    data
  });
};
export const getClientOptions = (data: any): Promise<{}> => {
  return request({
    url: '/message/getClientOptions',
    method: 'post',
    data
  });
};

export const getConfigData = (
  data: {
    // name: string;
    // title?: string;
  } = {}
): Promise<[]> => {
  return request({
    url: '/system/config/queryListByCondition',
    method: 'post',
    data
  });
};

export const getAreaData = (data?: {
  areaCode: number | string;
}): Promise<[]> => {
  return request({
    url: '/region/queryListByCondition',
    method: 'post',
    data
  });
};

/**author
 * 0 默认pc端 ；1 移动端
 */
export const getSSOData = (data?: {
  redirectUri: number | string;
  type: number;
}): Promise<any> => {
  return request({
    url: '/system/login/author',
    method: 'post',
    data
  });
};

export const getRoleList = (data?: {
  roleName?: string;
  pageNumber?: number;
  pageSize?: number;
  roleType: number;
}): Promise<any> => {
  return request({
    url: '/system/role/queryRoleList',
    method: 'post',
    data
  });
};
// export const getResUpload = (data: any): Promise<any> => {
//   return request({
//     url: '/file/upload',
//     method: 'post',
//     data
//   });
// };

export const getFileUpload = (data: any, callback?: any): Promise<any> => {
  return request.post('/file/upload', data, {
    onUploadProgress: callback,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
//
export const getUriDataLogin = (data: {
  encryptedUserInfo: string;
}): Promise<any> => {
  return request({
    url: '/thirdParty/login/signin',
    method: 'post',
    data
  });
};
export const getEmailConfirm = (data?: any): Promise<any> => {
  return request({
    url: '/costEmailApprovalRecord/confirm',
    method: 'post',
    data
  });
};
export const getConfirmPublicKey = (data?: any): Promise<any> => {
  return request({
    url: `/costEmailApprovalRecord/emailConfirmPublicKey?confirmId=${data?.confirmld}`,
    method: 'get'
  });
};
export const getServerTime = (): Promise<any> => {
  return request({
    url: '/common/getServerTime',
    method: 'get'
  });
};

export const dealerLogin = (
  data: DealerLoginInterface
): Promise<{ token: string }> => {
  return request({
    url: '/system/login/dealer/signin',
    method: 'post',
    data
  });
};
